module.exports = __webpack_public_path__ + "static/media/close.d0e967bb.svg";